import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { createNewPlaylist } from '../../../redux/actions/playlists'
import AloButton from '../../AloButton'
import { Modal } from 'react-bootstrap'

class NewPlaylistForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      playlistName: `New Playlist ${moment().format('L')}`
    }

    this.handleOnChange = this.handleOnChange.bind(this)
  }

  handleOnChange (e) {
    this.setState({ playlistName: e.target.value })
  }

  render () {
    return (
      <React.Fragment>
        <div className='new-playlist-form'>
          <h3>Name</h3>
          <input
            value={this.state.playlistName}
            onChange={this.handleOnChange}
          />
          <Modal.Footer>
            <button className='grey' onClick={this.props.onCancel}>
              Cancel
            </button>
            <AloButton
              processing={this.props.creatingPlaylist}
              onClick={() => {
                this.props.createNewPlaylist(
                  this.state.playlistName,
                  this.props.planEntryId,
                  this.props.onAdded
                )
              }}
            >
              Save
            </AloButton>
          </Modal.Footer>
        </div>
      </React.Fragment>
    )
  }
}

NewPlaylistForm.propTypes = {
  onAdded: PropTypes.func,
  onCancel: PropTypes.func,
  creatingPlaylist: PropTypes.bool,
  createNewPlaylist: PropTypes.func,
  planEntryId: PropTypes.number
}

const mapStateToProps = state => {
  return {
    creatingPlaylist: state.ui.playlists.creatingPlaylist
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createNewPlaylist: (playlistName, planEntryId, callback) => {
      dispatch(createNewPlaylist(playlistName, planEntryId, callback))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPlaylistForm)
